import { render } from "./TestCreate.vue?vue&type=template&id=58b376eb&scoped=true"
import script from "./TestCreate.vue?vue&type=script&lang=js"
export * from "./TestCreate.vue?vue&type=script&lang=js"

import "./TestCreate.vue?vue&type=style&index=0&id=58b376eb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58b376eb"]])

export default __exports__